import { createElement, lazy } from 'react';

import { urls } from '@treneo/shared/constants';
import type { RouteModule } from '@treneo/shared/router';
import { PublicLayoutRoute } from '@treneo/shared/ui';

const AuthLayoutRoute = lazy(() =>
  import('./components/layouts').then(module => ({ default: module.AuthLayoutRoute }))
);
const ForgotPasswordPage = lazy(() =>
  import('./pages/forgot-password-page').then(module => ({ default: module.ForgotPasswordPage }))
);
const JoinToCoursePage = lazy(() =>
  import('./pages/join-to-course-page').then(module => ({ default: module.JoinToCoursePage }))
);
const LoginPage = lazy(() =>
  import('./pages/login-page').then(module => ({ default: module.LoginPage }))
);
const RegistrationPage = lazy(() =>
  import('./pages/registration-page').then(module => ({ default: module.RegistrationPage }))
);
const ResetPasswordPage = lazy(() =>
  import('./pages/reset-password-page').then(module => ({ default: module.ResetPasswordPage }))
);

export const getAuthRouteModule = (): RouteModule => ({
  id: 'auth',
  routes: [
    {
      element: createElement(AuthLayoutRoute),
      children: [
        { path: urls.loginPage, element: createElement(LoginPage) },
        { path: urls.registrationPage, element: createElement(RegistrationPage) },
        {
          path: urls.confirmEmailAndActivateAccountPage(':code'),
          element: createElement(LoginPage)
        },
        { path: urls.forgotPasswordPage, element: createElement(ForgotPasswordPage) },
        {
          path: urls.resetPasswordPage(':hash'),
          element: createElement(ResetPasswordPage)
        }
      ]
    },
    {
      element: createElement(PublicLayoutRoute),
      children: [
        {
          path: urls.joinToCoursePage(':joinCode'),
          element: createElement(JoinToCoursePage, { shouldSkipConfirmation: false })
        }
      ]
    }
  ]
});
